import styled from 'styled-components';

import { NumberInput } from '@dreryk/react-components';

export const StyledPortionNumberInput = styled(NumberInput)`
   width: 90px;
`;

StyledPortionNumberInput.displayName = 'StyledPortionNumberInput';
